module.exports = __webpack_public_path__ + "static/img/1.305c028b.png";